import type { SpecMapComponentType } from '@wix/thunderbolt-symbols'

export const checkSupportsDynamicImportMaps = async (): Promise<boolean> => {
	const id = 'dynamic-importmap-test'

	// Step 1: Create and inject the first dynamic import map
	const firstModuleMapScript = document.createElement('script')
	firstModuleMapScript.type = 'importmap'
	firstModuleMapScript.id = `${id}-1`
	const firstModuleSpecifier = 'a'
	firstModuleMapScript.textContent = JSON.stringify({
		imports: { [firstModuleSpecifier]: 'data:text/javascript,export default true' },
	})
	document.head.appendChild(firstModuleMapScript)

	// Step 2: Create and inject th second dynamic import map, this should not add the module to the import map in old browsers.
	const secondModuleMapScript = document.createElement('script')
	secondModuleMapScript.type = 'importmap'
	secondModuleMapScript.id = `${id}-2`
	const secondModuleSpecifier = 'b'
	secondModuleMapScript.textContent = JSON.stringify({
		imports: { [secondModuleSpecifier]: 'data:text/javascript,export default true' },
	})

	try {
		document.head.appendChild(secondModuleMapScript)
		// Step 3: Import the module specified in the second dynamic import map, this should throw an error in old browsers.
		const module = await import(secondModuleSpecifier)
		return module.default === true
	} catch (e) {
		return false
	} finally {
		firstModuleMapScript.remove()
		secondModuleMapScript.remove()
	}
}

export const extractEditorReactComponentImports = (
	editorReactComponents: Array<SpecMapComponentType<'EDITOR_REACT_COMPONENT'>>
): Record<string, string> => {
	return editorReactComponents.reduce<Record<string, string>>((acc, component) => {
		const resources = component.data.resources
		const moduleSpecifier = resources?.client?.moduleSpecifier
		if (!moduleSpecifier) {
			return acc
		}
		const componentUrl = resources.client?.componentUrl
		const editorComponentUrl = resources.editor?.componentUrl
		const sdkUrl = resources.sdk?.url
		acc[moduleSpecifier] = editorComponentUrl || componentUrl || ''
		sdkUrl && (acc[`${moduleSpecifier}/sdk`] = sdkUrl)
		return acc
	}, {})
}
